import { Dtos } from "@inrev/common";
import * as z from "zod";
import { getSfaaExperience } from "../tools/definitions/get-sfaa-experience";
import { upperCased } from "./upper-cased";

export const SFAA_CHART_METRICS = ["lossRatio", "trailingLossRatio"] as const;

/**
 * The `get_sfaa_experience` call the agent just made, plus the ratio to plot. Like the tool, a
 * chart that narrows by nothing covers every line together.
 */
export const sfaaChartSchema = getSfaaExperience.input.extend({
	source: z.literal("sfaa"),
	sfaaCode: upperCased.optional(),
	location: upperCased.default(Dtos.Admin.SfaaClassExperience.US_TOTAL_LOCATION),
	metric: z.enum(SFAA_CHART_METRICS).default("lossRatio"),
	title: z.string().optional(),
});

export type SfaaChart = z.infer<typeof sfaaChartSchema>;

export const sfaaChartTitle = (chart: SfaaChart): string => {
	const parts = [
		chart.line,
		chart.subline,
		chart.sfaaCode === undefined ? chart.codeSeries : `Code ${chart.sfaaCode}`,
	].filter((part) => part !== undefined);
	return chart.title ?? (parts.length === 0 ? "All lines" : parts.join(" · "));
};
